import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03 2.3a.27.27 0 00-.27.27v7.73h6.47V2.57a.27.27 0 00-.27-.27H5.03zm6.2 8.8H4.76v2.33c0 .149.12.27.27.27h5.93c.15 0 .27-.121.27-.27V11.1zM3.96 2.57c0-.59.479-1.07 1.07-1.07h5.93c.59 0 1.07.48 1.07 1.07v10.86c0 .59-.48 1.07-1.07 1.07H5.03a1.07 1.07 0 01-1.07-1.07V2.57z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M2.954 8.873a.19.19 0 01-.017.25.194.194 0 01-.288-.016 1.78 1.78 0 010-2.198.193.193 0 01.285-.018.188.188 0 01.018.25 1.4 1.4 0 00.002 1.732z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.058 8.794c.1.13.08.31-.03.42a.324.324 0 01-.48-.025l-.001-.001a1.91 1.91 0 010-2.359v-.001a.323.323 0 01.479-.029c.113.113.13.294.028.422a1.27 1.27 0 00.002 1.57l.002.003zm-.409.313a1.78 1.78 0 010-2.198m0 2.198c.071.09.206.097.288.016a.19.19 0 00.017-.25",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M1.686 6.408a2.476 2.476 0 000 3.22.22.22 0 01-.017.292.221.221 0 01-.327-.018 2.92 2.92 0 010-3.768.224.224 0 01.327-.017c.079.078.09.207.017.291z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.342 9.902a2.92 2.92 0 010-3.768.224.224 0 01.327-.017c.079.078.09.207.017.291a2.476 2.476 0 000 3.22.22.22 0 01-.017.292.221.221 0 01-.327-.018zm.435-3.416a.336.336 0 00-.023-.454.344.344 0 00-.503.024 3.041 3.041 0 000 3.924.342.342 0 00.503.025.339.339 0 00.025-.453l-.001-.002a2.356 2.356 0 010-3.064z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M13.066 8.873a.19.19 0 00.017.25.194.194 0 00.288-.016 1.78 1.78 0 000-2.198.193.193 0 00-.285-.018.187.187 0 00-.018.25 1.401 1.401 0 01-.002 1.732z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.962 8.794a.32.32 0 00.03.42.324.324 0 00.48-.025l.001-.001a1.91 1.91 0 000-2.359v-.001a.323.323 0 00-.479-.029.317.317 0 00-.028.422 1.27 1.27 0 01-.002 1.57l-.002.003zm.409.313a1.78 1.78 0 000-2.198m0 2.198a.194.194 0 01-.288.016.19.19 0 01-.018-.25",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M14.324 6.391a2.477 2.477 0 010 3.22.22.22 0 00.018.292.221.221 0 00.326-.018 2.92 2.92 0 000-3.768.224.224 0 00-.326-.018.216.216 0 00-.018.292z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.668 9.885a2.92 2.92 0 000-3.768.224.224 0 00-.326-.018.216.216 0 00-.018.292 2.477 2.477 0 010 3.22.22.22 0 00.018.292.221.221 0 00.326-.018zm-.435-3.416a.336.336 0 01.024-.454.344.344 0 01.502.024 3.042 3.042 0 01.001 3.923.34.34 0 01-.528-.428 2.357 2.357 0 000-3.065z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M8.5 12.4a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }));
}
export default SvgComponent;